const setPaymentPageValuesAction = (_state, action) => {
    const { newState } = action.payload;
    return { ...newState };
};

export default setPaymentPageValuesAction;
